import { render, staticRenderFns } from "./centrifugeHome.vue?vue&type=template&id=842465e8&scoped=true&"
import script from "./centrifugeHome.vue?vue&type=script&lang=js&"
export * from "./centrifugeHome.vue?vue&type=script&lang=js&"
import style0 from "./centrifugeHome.vue?vue&type=style&index=0&id=842465e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842465e8",
  null
  
)

export default component.exports